import http from '../utils/http';
import {
    Message
}
from 'element-ui';

/**
 * 上传图片
 *
 * @param {*} file
 */
export const uploadPicture = (file) => {
    const formData = new FormData();
    formData.append('qqfile', file);
    return http({
        url: 'Common/UploadPicture',
        method: 'POST',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data: formData
    }).then(res => {
        const obj = {
            url: res.imageUrl,
            id: res.pictureId
        };
        return Promise.resolve(obj);
    }).catch(err => {
        console.error('uploadPicture -> err', err);
        Message({
            message: err.toString(),
            type: 'error',
            duration: 3 * 1000,
            showClose: true
        });
    });
};
